import { IS_DEVELOPMENT, IS_PROD } from "@/configs";
import * as Sentry from "@sentry/react";

export const initializeSentry = () => {
  const environment = (() => {
    if (IS_DEVELOPMENT) return "development";
    return IS_PROD ? "production" : "staging";
  })();

  Sentry.init({
    // get the DSN from SENTRY_DSN environment variable, add it on GitHub Secrets or Netlify Environment Variables
    dsn: import.meta.env.VITE_SENTRY_DSN,
    maxBreadcrumbs: 50,
    integrations: [],
    ignoreErrors: [
      "Can't find variable: gmo"
    ],
    environment,
    sampleRate: 1, // 0 to 1; 0.5 means 50% of the events will be sent (picked randomly)
    // ignoreErrors: [], // list of regex patterns to ignore sending the errors to Sentry
  });
}

export const setUser = Sentry.setUser;